<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>党费系统</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form inline :model="listParams" label-width="100px">
        <el-form-item label="审核状态：">
          <el-select style="width: 100%" size="small" v-model="listParams.status" placeholder="请选择审核状态">
            <el-option value="" label="全部"></el-option>
            <el-option value="01" label="已登记"></el-option>
            <el-option value="02" label="已保障"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户手机号：">
          <el-input maxlength="11" size="small" v-model="listParams.mobile" placeholder="请输入用户手机号"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh"> 查询 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>

          <!-- <form enctype="multipart/form-data">
            <el-upload
              ref="upload"
              class="upload-btn mgl20"
              accept="file"
              :headers="headers"
              :show-file-list="false"
              :action="uploadAction"
              :data="uploadParams"
              :before-upload="beforeUpload"
              :on-success="successCallback"
              :on-error="errorCallback"
            >
              <el-button size="small" type="success">批量导入用户</el-button>
            </el-upload>
          </form> -->

          <el-button class="align-left mgl20" type="primary" size="small" :disabled="tableData.length === 0" @click="exportExcel"> 导出用户 </el-button>
          <!--<form enctype="multipart/form-data">-->
          <!--<input type="file" id="importBtn" @change="importExcel">-->
          <!--</form>-->

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <!--<el-table-column-->
        <!--align="center"-->
        <!--width="60"-->
        <!--label="序号">-->
        <!--<template slot-scope="scope">-->
        <!--<span-->
        <!--v-text="(pager.pageIndex > 1 ?-->
        <!--(pager.pageIndex-1) * pager.pageSize :-->
        <!--0) + scope.$index + 1">-->
        <!--</span>-->
        <!--</template>-->
        <!--</el-table-column>-->

        <el-table-column prop="status" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-show="scope.row.status === '01'" style="color: teal">已登记</span>
            <span v-show="scope.row.status === '02'" style="color: rgba(0, 167, 0, 0.63)">已保障</span>
          </template>
        </el-table-column>

        <el-table-column prop="serialNo" align="center" label="人员编号"> </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号"> </el-table-column>

        <el-table-column prop="groupName" align="center" label="分组"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-show="scope.row.status === '02'" type="text" @click="changeItem(scope.row)"> 编辑 </el-button>

            <confirm-button
              v-show="scope.row.status === '01'"
              type="text"
              style="margin: 0 10px"
              title="该用户会从已生成党费中剔除，确认删除？"
              @confirmed="deleteItem(scope.row.id, scope.row.status)"
            >
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" @close="resetDialogForm" :close-on-click-modal="false" width="500px">
      <div>
        <el-form v-loading="dialogLoading" ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="人员编号：" prop="serialNo">
            <el-input :disabled="this.method === 'PUT'" size="small" placeholder="请输入人员编号" v-model="itemParams.serialNo"> </el-input>
          </el-form-item>

          <el-form-item label="手机号：" prop="mobile">
            <el-input :disabled="this.method === 'PUT'" size="small" placeholder="请输入手机号" :maxlength="11" v-model="itemParams.mobile"> </el-input>
          </el-form-item>

          <el-form-item label="分组列表：" prop="groupId">
            <el-select clearable style="width: 100%" v-model="itemParams.groupId" size="small" placeholder="请选择分组">
              <el-option v-for="item in groupList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveItem('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { download } from "../../../../utils/javascript/download";
export default {
  data() {
    return {
      listParams: {
        status: "",
        mobile: "",
        supplyId: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      supplyCentreList: [],
      dialogTitle: "",
      dialogVisible: false,
      method: "",
      url: "",
      isDisabled: false,
      dialogLoading: false,
      itemParams: {
        id: "",
        serialNo: "",
        mobile: "",
        groupId: "",
        supplyId: "",
      },
      logisticsSiteName: "",
      checkItemParams: {
        serialNo: [{ required: true, message: "请输入人员编号", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        groupId: [{ required: true, message: "请选择分组", trigger: "change" }],
      },
      exportUrl: "/partyFee/user/export",
      queryChanged: false,
      groupList: [],
    };
  },
  computed: {
    uploadAction() {
      return global.apiUrl + "/partyFee/user/import";
    },
    uploadParams() {
      return {
        supplyId: parseInt(this.$route.params.supplyId),
      };
    },
    headers() {
      return {
        "X-CA-Token": localStorage.getItem("TOKEN"),
      };
    },
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.itemParams.supplyId = this.$route.params.supplyId;
    this.loadSupplyCentreList();
    this.handleRefresh();
    this.loadGroupList();
  },
  methods: {
    handleRefresh() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      if (this.queryChanged) {
        this.pager.pageIndex = 1;
      }
      this.$http({
        url: global.apiUrl + "/partyFee/user/list",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          status: this.listParams.status,
          mobile: this.listParams.mobile,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 加载分组列表
     */
    loadGroupList() {
      Vue.ajaxGet(this, global.apiUrl + "/partyFee/user/group/list", {}).then(res => {
        this.groupList = res.list;
      });
    },
    /**
     * 新增
     */
    toCreate() {
      this.itemParams.serialNo = "";
      this.itemParams.mobile = "";
      this.itemParams.groupId = "";
      this.dialogVisible = true;
      this.dialogTitle = "新增用户";
      this.url = "/partyFee/user/add";
      this.method = "POST";
      delete this.itemParams.id;
    },
    /**
     * 上传前的操作
     * @param file
     */
    beforeUpload(file) {
      const Xls = file.name.split(".");
      if (Xls[1] === "xls" || Xls[1] === "xlsx") {
        return true;
      } else {
        this.$message.error("上传文件只能是 xls/xlsx 格式!");
        return false;
      }
    },
    /**
     * 成功回调
     * @param res
     * @param file
     * @param fileList
     */
    successCallback(res, file, fileList) {
      if (res.apiStatus === 0 && res.sysStatus === 0) {
        this.$message.success(res.info);
        this.loadTableData();
      } else {
        this.$message.error(res.info);
      }
    },
    /**
     * 错误回调
     * @param err
     * @param file
     * @param fileList
     */
    errorCallback(err, file, fileList) {
      this.$message.error(err);
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.queryChanged = false;
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.queryChanged = false;
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 初始化供应点列表
     */
    loadSupplyCentreList() {
      this.$http({
        url: global.apiUrl + "/logistics/index",
        methods: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.supplyCentreList = res.body.data.dataList;
              if (this.method === "PUT") {
                this.supplyCentreList.map(item => {
                  if (this.itemParams.logisticsSiteId === item.id) {
                    this.logisticsSiteName = item.title;
                  }
                });
                setTimeout(() => {
                  this.dialogLoading = false;
                }, 300);
              }
            } else {
              this.dialogLoading = false;
              this.supplyCentreList = [];
            }
          }
        })
        .catch(err => {
          this.dialogLoading = false;

          console.error(err);
        });
    },
    /**
     * 保存新增或修改
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: this.itemParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.$message.success(res.body.info);
                this.loadTableData();
                setTimeout(() => {
                  this.isDisabled = false;
                }, 500);
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 修改条目数据
     * @param row
     */
    changeItem(row) {
      this.dialogTitle = "编辑用户";
      this.itemParams.serialNo = row.serialNo;
      this.itemParams.groupId = row.groupId;
      this.itemParams.mobile = row.mobile;
      this.itemParams.id = row.id;
      this.method = "PUT";
      this.url = "/partyFee/user/save";
      this.dialogVisible = true;
    },
    /**
     * 删除条目数据
     * @param id
     * @param status
     */
    deleteItem(id, status) {
      this.$http({
        url: global.apiUrl + "/partyFee/user/delete?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 导出EXCEL
     */
    exportExcel() {
      download(this.exportUrl, this.listParams, "用户管理");

      // this.$router.open({
      //   path: this.exportUrl,
      //   query: this.listParams,
      //   type: "excel"
      // });
    },
  },
  watch: {
    "listParams.status": function (val, oldVal) {
      if (val !== oldVal) {
        this.queryChanged = true;
      } else {
        this.queryChanged = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
